import { render, staticRenderFns } from "./vuetiform-radios.vue?vue&type=template&id=54155f97&scoped=true&"
import script from "./vuetiform-radios.vue?vue&type=script&lang=js&"
export * from "./vuetiform-radios.vue?vue&type=script&lang=js&"
import style0 from "./vuetiform-radios.vue?vue&type=style&index=0&id=54155f97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54155f97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../@vue-modules/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
